/** 权限级别枚举（D < V < R < E < A；R=可审核，当前仅数据抽取模板使用） */
export enum RightEnum {
  Deny = "D",
  View = "V",
  Review = "R",
  Edit = "E",
  Admin = "A",
}

/** 有效资源权限的最终来源，文件与知识库共用。 */
export enum ResourceRightSourceEnum {
  Owner = "owner",
  UserDeny = "userDeny",
  Administrator = "administrator",
  DirectShare = "directShare",
  ProjectMember = "projectMember",
  Rbac = "rbac",
  Public = "public",
  Link = "link",
  Deny = "deny",
}

/** 直接分享的目标类型 */
export enum ResShareTargetTypeEnum {
  User = "user",
  Role = "role",
}

/** 资源类型枚举 */
export enum ResTypeEnum {
  Kb = "kb",
  ChatBot = "chatBot",
  DocCenterFile = "docCenterFile",
  DataExtractTmpl = "dataExtractTmpl",
  DataSource = "dataSource",
  DataTableRegistry = "dataTableRegistry",
  Project = "project",
  /** 数据抽取统一运行(波次3 3A-4.5 注册) */
  Run = "run",
  /** 数据资产(波次4 4A-PLAT 注册;取值对齐 ResourceTypeEnum) */
  DataAsset = "dataAsset",
  /** 数据资产发布版本(波次4 4A-PLAT 注册;取值对齐 ResourceTypeEnum) */
  DataAssetVersion = "dataAssetVersion",
  /** 语义数据模型(波次6 6A-PLAT 注册;取值对齐 ResourceTypeEnum) */
  SemanticDataModel = "semanticDataModel",
  /** 语义数据模型版本(波次6 6A-PLAT 注册;取值对齐 ResourceTypeEnum) */
  SemanticDataModelVersion = "semanticDataModelVersion",
  /** 结构化数据集(D30 丙方案:数据中心源头数据资源级管控) */
  UnifiedDataset = "unifiedDataset",
  /** 语义概念(21-领域上下文改版:按领域容器级授权,领域即权限边界) */
  SemanticConcept = "semanticConcept",
  /** 语义数据字典(21-领域上下文改版:按领域容器级授权) */
  SemanticVocabulary = "semanticVocabulary",
  /** 度量与单位(21-领域上下文改版:按领域容器级授权) */
  SemanticQuantity = "semanticQuantity",
  /** GlassChat 实验笔记本模板 */
  NotebookTemplate = "notebookTemplate",
  /** GlassChat 实验笔记本文件夹 */
  NotebookFolder = "notebookFolder",
  /** 工坊工具（39-工具技能坊：V=可挂载使用,E=编辑定义,A=审批管理） */
  AgentTool = "agentTool",
  /** 工坊技能（39-工具技能坊：V=可引用,E=编辑,A=管理；组合资产） */
  BotSkill = "botSkill",
}

/** 不豁免租户管理员(tAdm)/租户所有者(owner)的资源类型：
 *  这些资源域内 tAdm 与 owner 不直通 Admin，按成员/分享记录/RBAC 角色解算；sAdm 不受影响 */
export const TENANT_ADM_BYPASS_EXCLUDED_RES_TYPES: ReadonlySet<ResTypeEnum> =
  new Set([ResTypeEnum.Project]);

/** 资源目标类型枚举 */
export enum TargetTypeEnum {
  pack = "pack",
  item = "item",
}

/** 权限作用域枚举 — 控制数据可见性边界
 * 框架只负责计算出当前的配置下，最终的scope的值，具体每个scope如何限制和过滤由业务本身决定
 * */
export enum PermitScopeEnum {
  self = "self",
  dept = "dept",
  /* 关联可用，关联的概念由业务自行决定 */
  rel = "rel",
  tenant = "tenant",
}
